import { Link } from 'react-router-dom';
import './css/SiteLogo.css';

type SiteLogoProps = {
  className?: string;
};

export default function SiteLogo({ className }: SiteLogoProps) {
  return (
    <Link to="/" className={['site-logo', className].filter(Boolean).join(' ')}>
      <img
        src={`${process.env.PUBLIC_URL}/sciplex-logo.png`}
        alt=""
        className="site-logo__icon"
      />
      <span className="site-logo__text">Sciplex</span>
    </Link>
  );
}
